import React from 'react';
import { Box } from '@mui/material';
// own
import { createSx } from '../../../utils';

const sx = createSx({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 0.5,
    flexGrow: 0,
    overflow: 'auto',
    backgroundColor: 'neutral.containerHighest',
    border: '1px solid',
    borderColor: 'neutral.outlineVariant',
    '& button': {
      borderRadius: 0,
    },
    '& > *': {
      borderRight: '1px solid',
      borderColor: 'neutral.outlineVariant',
    },
    '& > *:last-of-type': {
      borderRight: 'none',
    },
  },
});

interface Props {
  children: React.ReactNode;
}

const ButtonGroupWrapper = ({ children }: Props) => {
  return (
    <Box sx={sx.root}>
      {children}
    </Box>
  );
};

export default ButtonGroupWrapper;